module.exports = __webpack_public_path__ + "resource/img/image033.feeeeb2e.png";